/*
 * Gemeinsame Formen des Registrierportals: das Portal selbst liest sie aus
 * /api/portal/content, die Inhaltspflege (/settings/portal) schreibt sie als
 * JSON-Fassungen der Arten `branding` und `texts`. Spiegel von
 * PortalBranding und PortalTexts in HVACloud.Features.Identity.Portal.
 */

export interface PortalBranding {
  productName?: string | null;
  logoAssetId?: string | null;
  logoAlt?: string | null;
  primaryColor?: string | null;
  primaryTextColor?: string | null;
  backgroundColor?: string | null;
  textColor?: string | null;
  senderName?: string | null;
}

export interface PortalTexts {
  title?: string;
  intro?: string;
  invalidInvitation?: string;
  notReady?: string;
  submittedText?: string;
  confirmedText?: string;
  awaitingApprovalText?: string;
  doneText?: string;
  confirmMailSubject?: string;
  confirmMailBody?: string;
  approvedMailSubject?: string;
  approvedMailBody?: string;
  rejectedMailSubject?: string;
  rejectedMailBody?: string;
}

/** Felder der Texte in der Inhaltspflege, mit Bezeichnung und ob mehrzeilig. */
export const TEXT_FIELDS: ReadonlyArray<{ key: keyof PortalTexts; label: string; multiline: boolean }> = [
  { key: 'title', label: 'Überschrift', multiline: false },
  { key: 'intro', label: 'Einleitung', multiline: true },
  { key: 'invalidInvitation', label: 'Code ungültig oder abgelaufen', multiline: true },
  { key: 'notReady', label: 'Portal noch nicht eingerichtet', multiline: true },
  { key: 'submittedText', label: 'Nach dem Absenden', multiline: true },
  { key: 'confirmedText', label: 'E-Mail bestätigt', multiline: true },
  { key: 'awaitingApprovalText', label: 'Wartet auf Freigabe', multiline: true },
  { key: 'doneText', label: 'Zugang eingerichtet', multiline: true },
  { key: 'confirmMailSubject', label: 'Mail Bestätigung: Betreff', multiline: false },
  { key: 'confirmMailBody', label: 'Mail Bestätigung: Text ({name}, {link}, {plant}, {product})', multiline: true },
  { key: 'approvedMailSubject', label: 'Mail Freigabe: Betreff', multiline: false },
  { key: 'approvedMailBody', label: 'Mail Freigabe: Text', multiline: true },
  { key: 'rejectedMailSubject', label: 'Mail Ablehnung: Betreff', multiline: false },
  { key: 'rejectedMailBody', label: 'Mail Ablehnung: Text', multiline: true },
];

export interface PortalDocumentDto {
  documentId: string;
  kind: string;
  consentMode: 'none' | 'required' | 'optional';
  versionId: string;
  version: number;
  title: string;
  body: string;
  consentLabel: string | null;
  contentHash: string;
  publishedAt: string;
}

export interface PortalContent {
  ready: boolean;
  language: string;
  branding: {
    productName?: string | null;
    logoUrl?: string | null;
    logoAlt?: string | null;
    primaryColor?: string | null;
    primaryTextColor?: string | null;
    backgroundColor?: string | null;
    textColor?: string | null;
  };
  texts: Required<PortalTexts>;
  documents: PortalDocumentDto[];
}

/** Anzeigename einer Dokumentart. */
export function kindLabel(kind: string): string {
  switch (kind) {
    case 'branding': return 'Erscheinungsbild';
    case 'texts': return 'Texte und Mails';
    case 'terms': return 'AGB / Nutzungsbedingungen';
    case 'privacy': return 'Datenschutzerklärung';
    case 'imprint': return 'Impressum';
    default: return kind;
  }
}

/** Nur #rgb oder #rrggbb, wie der Server prüft. */
export function isColor(value: string | null | undefined): value is string {
  return !!value && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);
}
